const appNames = {
  CDM: "CDM",
  CENTRAL_COMMAND: "Central Command",
  SSGUI: "Authentic",
  ADMINS: "Admins",
}

export const { ADMINS, CDM, CENTRAL_COMMAND, SSGUI } = appNames
